import { HostListener, Component } from '@angular/core';

import {
    NavParams,
    ViewController } from 'ionic-angular';

@Component({
    selector: 'page-view-horse-picture',
    templateUrl: 'view-horse-picture.html'
})
export class ViewHorsePicturePage {
    pictureUrl: any;

    constructor(navParams : NavParams, private viewController : ViewController) {
        this.pictureUrl = navParams.get("pictureUrl");
    }

    done() {
        this.viewController.dismiss();
    }

    back() {
        this.viewController.dismiss();
    }

    _bdClick() {
        return this.viewController.dismiss();
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 27 && this.viewController.isLast()) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/horse/view-horse-picture.ts